import { render, staticRenderFns } from "./CarouselTextSettings.vue?vue&type=template&id=45a3d57e&scoped=true&"
import script from "./CarouselTextSettings.vue?vue&type=script&lang=js&"
export * from "./CarouselTextSettings.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTextSettings.vue?vue&type=style&index=0&id=45a3d57e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3d57e",
  null
  
)

export default component.exports